<template>
  <div class="contact-support-email-dialog-container" v-if="show">
    <wxc-overlay :left="left" :show="true" :hasAnimation="false"></wxc-overlay>
    <div class="dialog-box"
         :style="{top:top+'px', left: ((isWeb ? left : 0) + 20) + 'px', right: ((isWeb ? right : 0) + 20) + 'px'}">
      <div class="dialog-content">
        <weex-image
          class="dialog-cross-image"
          @click="crossClicked"
          :src="crossImage">
        </weex-image>

        <div class="dialog-content-below-cross"></div>

        <div class="input_container">
          <weex-text class="input_label">Subject</weex-text>
          <input
            class="input_with_border_bottom"
            :value="subjectFromUser"
            @input="subjectFromUser=$event.target.value">
        </div>

        <div class="input_container" style="padding: 10px">
          <weex-text class="input_label">Description</weex-text>
          <textarea
            class="border"
            style="padding: 10px; width: 100%"
            rows="10"
            @input="bodyFromUser=$event.target.value"
            :value="bodyFromUser"></textarea>
        </div>

        <wxc-button
          text="Send"
          size="big"
          type="blue"
          class="margin_top_20 margin-bottom-20 horizontal_center"
          @wxcButtonClicked="onSendMail"
        ></wxc-button>
      </div>
    </div>
  </div>
</template>

<script>
import WxcButton from "@/../weex-ui/packages/wxc-button/index";
import WxcOverlay from "@/../weex-ui/packages/wxc-overlay/index";
import { ImageResourcesUtil } from "@/utils/ImageResourcesUtil";
import EzUtils from "@/utils/EzUtils";
import AlertService from "@/components/core/alert/AlertService";
import { MessageConstants } from "@/utils/MessageConstantUtil";
import env from "@/utils/env";

export default {
  components: { WxcOverlay, WxcButton },
  data: () => ({
    subjectFromUser: '',
    bodyFromUser: '',
  }),
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },

    subject: {
      type: String,
      default: ''
    },

    body: {
      type: String,
      default: ''
    },

    top: {
      type: Number,
      default: 150
    },

    left: {
      type: Number,
      default: 0
    },

    right: {
      type: Number,
      default: 0
    },

    bottom: {
      type: Number,
      default: 50
    }
  },

  methods: {
    onSendMail() {
      if (this.checkForValidation()) {
        this.$emit("sendMail", { 'subject': this.subjectFromUser, 'body': this.bodyFromUser });
      }
    },

    crossClicked() {
      this.$emit("dialogClose", {})
    },

    checkForValidation() {
      if (EzUtils.isEmpty(this.subjectFromUser)) {
        AlertService.showToast(MessageConstants.ENTER_SUBJECT);
        return false;
      }
      if (EzUtils.isEmpty(this.bodyFromUser)) {
        AlertService.showToast(MessageConstants.ENTER_DESCRIPTION);
        return false;
      }
      return true;
    }
  },

  watch: {
    show() {
      if (this.show) {
        this.subjectFromUser = this.subject;
        this.bodyFromUser = this.body;
      }
    }
  },

  computed: {
    crossImage() {
      return ImageResourcesUtil.getImageLink(ImageResourcesUtil.CANCEL_RED)
    },

    isWeb() {
      return env.isWebPlatform();
    }
  }
};
</script>

<style scoped src="../../assets/style/base.css"></style>

<style scoped>
.contact-support-email-dialog-container {
  position: fixed;
  z-index: 9999;
}
</style>
